import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "When and where is AI World Congress 2026?",
    answer: "AI World Congress 2026 takes place on November 25th-26th, 2026 at The Great Hall, Kensington Conference and Events Centre, Hornton St, Kensington, London W8 7NX."
  },
  {
    question: "What topics will be covered at the conference?",
    answer: "The conference covers a wide range of AI topics including machine learning, generative AI, AI ethics, AI in business, smart cities, healthcare AI, financial AI, and the future of work with artificial intelligence."
  },
  {
    question: "Who should attend AI World Congress?",
    answer: "AI World Congress is designed for CTOs, CIOs, AI engineers, data scientists, business leaders, policymakers, researchers, and anyone interested in the latest developments in artificial intelligence."
  },
  {
    question: "What types of tickets are available?",
    answer: "We offer Early Bird passes, VIP passes with exclusive networking opportunities, and standard Full Price passes. All tickets include access to keynotes, sessions, conference materials, and refreshments."
  },
  {
    question: "Is there a virtual attendance option?",
    answer: "AI World Congress 2026 is primarily an in-person event to maximize networking opportunities. However, select sessions may be available for virtual viewing. Check our website for updates."
  },
  {
    question: "How can I become a speaker at AI World Congress?",
    answer: "If you're interested in speaking at AI World Congress 2026, please visit our Contact page and submit your proposal. We welcome speakers from diverse backgrounds in the AI ecosystem."
  },
  {
    question: "Are there sponsorship opportunities available?",
    answer: "Yes, we offer various sponsorship packages for companies looking to showcase their AI solutions and connect with industry leaders. Contact us for our sponsorship prospectus."
  },
  {
    question: "What is the refund policy for tickets?",
    answer: "Full 100% refund within 14 days of booking. After that our terms apply. Tickets are non-refundable but can be transferred to another attendee or next event. Please contact us for assistance."
  }
];

const FAQSection = () => {
  // FAQ structured data is already in index.html - no duplicate needed here

  return (
    <section className="py-20 bg-gradient-to-b from-ai-dark to-purple-950/30">

      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Everything you need to know about AI World Congress 2026
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg px-6 overflow-hidden"
              >
                <AccordionTrigger className="text-left text-white hover:text-orange-400 py-5 text-base md:text-lg font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 pb-5 text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
